module.exports = __webpack_public_path__ + "static/media/FlowDevelop.82ba0876.svg";